import { FC } from "react";
import { TextFormField } from "@blanket/components/formFields/FormFields";
import {
  canEnterCreationShareFields,
  requiresPartnerExamField,
} from "../../eligibility/participantEligibilityRules";
import { getNonLawyerOwnerShareHelper } from "../../eligibility/participantEligibilityUi";

type OwnerAndVoteShareFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  ownerShareHelperText?: string;
  ownerShareHelperRole?: "deltager" | "interessent";
};

export const OwnerAndVoteShareFields: FC<OwnerAndVoteShareFieldsProps> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  ownerShareHelperText,
  ownerShareHelperRole = "deltager",
}) => {
  if (!canEnterCreationShareFields(isLawyerOrLawFirm, passedPartnerExam)) {
    return null;
  }

  const helperText = requiresPartnerExamField(isLawyerOrLawFirm)
    ? (ownerShareHelperText ??
      getNonLawyerOwnerShareHelper(ownerShareHelperRole))
    : undefined;

  return (
    <div className="blanket-two-col">
      <TextFormField
        name={`${namePrefix}.ownerShare`}
        label="Ejerandel (%)"
        id={`${idPrefix}-owner`}
        isRequired
        type="number"
        helperText={helperText}
      />
      <TextFormField
        name={`${namePrefix}.voteShare`}
        label="Stemmeandel (%)"
        id={`${idPrefix}-vote`}
        isRequired
        type="number"
      />
    </div>
  );
};
